// extracted by mini-css-extract-plugin
module.exports = {"big":"Loader_big__HfBk7","middle":"Loader_middle__nBpIe"};